import { ReportComponent } from './../../report/report.component';
import { element } from "protractor";
import { ParametersService } from "./../../service/parameters.service";
import { Report, ReportChecklist } from "./../../model/report.model";
import { CheckListVehicle } from "./../../model/settings.model";
import { CheckList } from "./../../model/categorie";
import { first } from "rxjs/operators";
import { VehicleModule } from "./../../vehicle/vehicle.module";
import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { VehicleSettings } from "../../model/settings.model";
import { VehicleService } from "../../service/vehicle.service";
import { Vehicle } from "../../model/vehicle.model";
import { ToastService } from "../../service/toast.service";
import { ReportService } from "../../service/report.service";
import { VehiculeChecklist } from "../../model/reportChecklist";
import { ConfigurationServicePlaceholders } from "aws-sdk/lib/config_service_placeholders";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: "app-report-check-list",
  templateUrl: "./report-check-list.component.html",
  styleUrls: ["./report-check-list.component.less"],
})
export class ReportCheckListComponent implements OnInit, OnChanges {
   @Input() vehicleId: string;
  @Input() vehicleSettings: VehicleSettings;
  @Input() newClass : string = "";
  @Input() report: Report;
  private eventsSubscription: Subscription;
  
  checklistDisplay: CheckListVehicle[]; // from settings 

  reportListened: Report;
  vehicle: Vehicle;
  reportChecklist: VehiculeChecklist[] = [];

  constructor(
    private readonly _vehicleService: VehicleService,
    private readonly _toastService: ToastService,
    private readonly _ReportService: ReportService
  ) {}


  ngOnInit(){
   }
  
  async saveChange(id, value ) {
    this._toastService.toastOpen(true);
    let index = this.reportChecklist.findIndex(e => { return e.id === id})
    if (index!==-1)
      this.report.vehicleChecklist[index].value = value 
    else if (this.report.vehicleChecklist === undefined){
      this.report.vehicleChecklist = []
      this.report.vehicleChecklist.push({id, value})
    }
    else
    {
      for (var i = 0; i <= this.report.vehicleChecklist.length - 1; i++) 
        if (this.report.vehicleChecklist[i].id == id )
          this.report.vehicleChecklist.splice(i)
      this.report.vehicleChecklist.push({id, value})
    }
    this._ReportService.saveChecklist(this.report, this.report.vehicleChecklist);
    this._toastService.toastOpen(false);
  }

  ngOnChanges() {
    this.loadChecklist()
  }

  loadChecklist() {
    this._vehicleService.get(this.vehicleId)
        .then((vehicle) => {
          this.vehicle = vehicle
          if (this.report && this.report.vehicleChecklist){
            this.report.vehicleChecklist.forEach(element => {
              let index = this.vehicleSettings.checklist.findIndex(e => {return e.id === element.id})
              if (index !== -1 )
                  this.vehicleSettings.checklist[index].value = element.value
            })
          this.checklistDisplay = [];
          for (var i = 0; i <= this.vehicleSettings.checklist.length - 1; i++ ) {
            if (this.vehicleSettings.checklist[i].classIds.includes(this.vehicle.class) && this.vehicleSettings.checklist[i].reportType.includes(this.report.typeReport))
                this.checklistDisplay.push(this.vehicleSettings.checklist[i])
          }}
        });
  }
}


// WEBPACK FOOTER //
// ./src/app/element/report-check-list/report-check-list.component.ts